import _ from 'lodash';
import {throwError} from 'rxjs';

export const errorMessageObservable = (error) => {
  if (_.isNil(error.response)) {
    return throwError(new Error(error.message));
  }
  return throwError(new Error(error.response.message));
};
